import React, { Component } from 'react';
import { Drawer, Button, Form, Input, DatePicker, message } from 'antd';
import moment from 'moment';
import { updatePaymentApi } from '../api/subscriptionEdits';

class EditPaymentDrawer extends Component {
    state = {
        loading: false
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                this.setState({ loading: true });

                const payload = {
                    subscriptionId: this.props.subscriptionId,
                    paymentId: this.props.data._id,
                    newPaymentData: {
                        ...values,
                        receivedDate: values.receivedDate ? values.receivedDate.format('YYYY-MM-DD') : null
                    }
                };

                const { error } = await updatePaymentApi(payload);
                this.setState({ loading: false });

                if (!error) {
                    message.success("Payment Updated Successfully");
                    this.props.onSuccess();
                    this.props.onClose();
                } else {
                    message.error("Failed to update payment");
                }
            }
        });
    };

    render() {
        const { visible, onClose, data, form } = this.props;
        const { getFieldDecorator } = form;
        const { loading } = this.state;
        const initialAmount = data ? data.amount : '';
        const initialMode = data ? data.modeOfPayment : '';
        const initialDate = data && data.receivedDate ? moment(data.receivedDate) : null;

        return (
            <Drawer
                title="Edit Payment Details"
                width={400}
                onClose={onClose}
                visible={visible}
                destroyOnClose={true}
            >
                <Form layout="vertical" onSubmit={this.handleSubmit} style={{ padding: '20px' }}>
                    <Form.Item label="Amount">
                        {getFieldDecorator('amount', {
                            initialValue: initialAmount,
                            rules: [{ required: true, message: 'Please enter amount' }],
                        })(<Input type="number" />)}
                    </Form.Item>

                    <Form.Item label="Mode of Payment">
                        {getFieldDecorator('modeOfPayment', {
                            initialValue: initialMode,
                            rules: [{ required: true, message: 'Please enter mode' }],
                        })(<Input />)}
                    </Form.Item>

                    <Form.Item label="Received Date">
                        {getFieldDecorator('receivedDate', {
                            initialValue: initialDate,
                            rules: [{ required: true, message: 'Please select date' }],
                        })(<DatePicker style={{ width: '100%' }} />)}
                    </Form.Item>

                    <div style={{ textAlign: 'right', marginTop: 20 }}>
                        <Button onClick={onClose} style={{ marginRight: 8 }}>Cancel</Button>
                        <Button type="primary" htmlType="submit" loading={loading}>Update</Button>
                    </div>
                </Form>
            </Drawer>
        );
    }
}

export default Form.create()(EditPaymentDrawer);